export const CONTENT_MAX_WIDTH = 1168;

export const Breakpoints = {
	mobileSmall: 320,
	mobileLarge: 480,
	tablet: 768,
	desktop: 1024,
	desktopLarge: 1440,
	maxWidth: CONTENT_MAX_WIDTH,
} as const;

type ScreenSize = keyof typeof Breakpoints;

export function minWidth(screenSize: ScreenSize): string {
	return `@media only screen and (min-width: ${Breakpoints[screenSize]}px)`;
}

export function maxWidth(screenSize: ScreenSize): string {
	return `@media only screen and (max-width: ${Breakpoints[screenSize] - 1}px)`;
}

export function betweenWidths(minScreenSize: ScreenSize, maxScreenSize: ScreenSize): string {
	return `@media only screen and (min-width: ${Breakpoints[minScreenSize]}px) and (max-width: ${
		Breakpoints[maxScreenSize] - 1
	}px)`;
}
